export const TOKEN_IS_VERIFIED = "Token is not verified!";
export const TOKEN_IS_ADMIN = "You are not the admin or the owner of the token!";
export const UNKNOWN_ERROR = "There was an error retrieving the information of the token!";
